export default "__VITE_ASSET__02feae96__"